import { render, staticRenderFns } from "./RinvL_List.vue?vue&type=template&id=89854728"
import script from "./RinvL_List.vue?vue&type=script&lang=js"
export * from "./RinvL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports